const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 278 144",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.014,
    y: 33.307,
    width: 20.766,
    height: 92.483,
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.546,
    y: 18.645,
    width: 20.766,
    height: 107.132,
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.077,
    y: 33.28,
    width: 20.766,
    height: 92.483,
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.609,
    y: 56.554,
    width: 20.766,
    height: 69.196,
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.14,
    y: 56.554,
    width: 20.766,
    height: 69.182,
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.672,
    y: 28.201,
    width: 20.766,
    height: 97.521,
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.78,
    y: 51.542,
    width: 20.766,
    height: 74.248,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.311,
    y: 43.812,
    width: 20.766,
    height: 81.965,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.843,
    y: 28.58,
    width: 20.766,
    height: 97.183,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.375,
    y: 63.493,
    width: 20.766,
    height: 62.256,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.906,
    y: 43.812,
    width: 20.766,
    height: 81.924,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.438,
    y: 38.468,
    width: 20.766,
    height: 87.253,
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.694,143.369l-0,-0.77l1.771,-0l-0,-5.896l-1.397,0.88l-0.385,-0.671l2.035,-1.298l0.649,-0l-0,6.985l1.661,-0l-0,0.77l-4.334,-0Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.152,143.369l0,-0.682l2.651,-2.86c0.374,-0.411 0.644,-0.785 0.809,-1.122c0.165,-0.338 0.247,-0.682 0.247,-1.034c0,-0.902 -0.524,-1.353 -1.573,-1.353c-0.784,-0 -1.477,0.293 -2.079,0.88l-0.341,-0.704c0.286,-0.294 0.651,-0.53 1.095,-0.71c0.443,-0.179 0.911,-0.269 1.402,-0.269c0.778,-0 1.373,0.181 1.788,0.544c0.414,0.363 0.621,0.878 0.621,1.546c0,0.462 -0.113,0.915 -0.341,1.358c-0.227,0.444 -0.575,0.915 -1.045,1.414l-2.079,2.222l3.784,-0l0,0.77l-4.939,-0Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.207,143.468c-0.514,-0 -1.001,-0.079 -1.463,-0.237c-0.462,-0.157 -0.851,-0.387 -1.166,-0.687l0.33,-0.715c0.359,0.293 0.722,0.506 1.089,0.638c0.366,0.132 0.762,0.198 1.188,0.198c0.557,-0 0.984,-0.123 1.281,-0.369c0.297,-0.245 0.446,-0.607 0.446,-1.083c-0,-0.455 -0.151,-0.8 -0.451,-1.034c-0.301,-0.235 -0.737,-0.352 -1.309,-0.352l-1.144,-0l-0,-0.781l1.067,-0c0.498,-0 0.893,-0.13 1.182,-0.391c0.29,-0.26 0.435,-0.618 0.435,-1.072c-0,-0.404 -0.134,-0.715 -0.402,-0.935c-0.267,-0.22 -0.647,-0.33 -1.138,-0.33c-0.807,-0 -1.511,0.293 -2.112,0.88l-0.33,-0.704c0.286,-0.308 0.651,-0.548 1.094,-0.721c0.444,-0.172 0.911,-0.258 1.403,-0.258c0.748,-0 1.333,0.176 1.754,0.528c0.422,0.352 0.633,0.839 0.633,1.463c-0,0.432 -0.11,0.812 -0.33,1.138c-0.22,0.327 -0.525,0.563 -0.913,0.71c0.462,0.124 0.821,0.354 1.078,0.687c0.256,0.334 0.385,0.746 0.385,1.238c-0,0.667 -0.233,1.199 -0.699,1.595c-0.465,0.396 -1.102,0.594 -1.908,0.594Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.974,143.369l0,-1.661l-3.575,-0l0,-0.682l3.729,-5.412l0.759,-0l0,5.324l1.155,-0l0,0.77l-1.155,-0l0,1.661l-0.913,-0Zm0,-2.431l0,-3.839l-2.64,3.839l2.64,-0Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.125,143.468c-0.499,-0 -0.976,-0.081 -1.43,-0.242c-0.455,-0.162 -0.84,-0.389 -1.155,-0.682l0.341,-0.715c0.682,0.557 1.426,0.836 2.233,0.836c0.535,-0 0.957,-0.151 1.265,-0.451c0.308,-0.301 0.462,-0.697 0.462,-1.188c-0,-0.506 -0.147,-0.921 -0.44,-1.243c-0.294,-0.323 -0.697,-0.484 -1.21,-0.484c-0.741,-0 -1.324,0.308 -1.749,0.924l-0.66,-0l-0,-4.609l4.499,-0l-0,0.77l-3.608,-0l-0,2.772c0.425,-0.426 0.986,-0.638 1.683,-0.638c0.484,-0 0.905,0.102 1.265,0.308c0.359,0.205 0.636,0.493 0.83,0.863c0.195,0.371 0.292,0.801 0.292,1.293c-0,0.484 -0.107,0.913 -0.319,1.287c-0.213,0.374 -0.515,0.667 -0.908,0.88c-0.392,0.212 -0.856,0.319 -1.391,0.319Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.056,143.468c-0.916,-0 -1.622,-0.332 -2.117,-0.996c-0.495,-0.663 -0.743,-1.593 -0.743,-2.788c0,-1.342 0.275,-2.373 0.825,-3.091c0.55,-0.719 1.32,-1.078 2.31,-1.078c0.396,-0 0.794,0.084 1.194,0.253c0.399,0.168 0.728,0.396 0.984,0.682l-0.33,0.704c-0.271,-0.279 -0.566,-0.488 -0.885,-0.627c-0.319,-0.14 -0.647,-0.209 -0.985,-0.209c-0.718,-0 -1.27,0.267 -1.655,0.803c-0.385,0.535 -0.578,1.331 -0.578,2.387l0,0.539c0.14,-0.484 0.398,-0.862 0.776,-1.133c0.377,-0.272 0.823,-0.407 1.336,-0.407c0.455,-0 0.858,0.104 1.21,0.313c0.352,0.209 0.627,0.497 0.825,0.864c0.198,0.366 0.297,0.788 0.297,1.265c0,0.491 -0.104,0.926 -0.313,1.303c-0.209,0.378 -0.499,0.675 -0.869,0.891c-0.371,0.217 -0.798,0.325 -1.282,0.325Zm-0.055,-0.77c0.492,-0 0.889,-0.158 1.194,-0.473c0.304,-0.316 0.456,-0.73 0.456,-1.243c0,-0.506 -0.152,-0.919 -0.456,-1.238c-0.305,-0.319 -0.702,-0.478 -1.194,-0.478c-0.491,-0 -0.889,0.159 -1.193,0.478c-0.305,0.319 -0.457,0.732 -0.457,1.238c0,0.513 0.152,0.927 0.457,1.243c0.304,0.315 0.702,0.473 1.193,0.473Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.557,143.369l3.608,-6.974l-4.103,-0l-0,-0.781l5.126,-0l-0,0.682l-3.63,7.073l-1.001,-0Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.457,143.468c-0.872,-0 -1.551,-0.189 -2.035,-0.567c-0.484,-0.377 -0.726,-0.907 -0.726,-1.589c0,-0.477 0.13,-0.884 0.391,-1.221c0.26,-0.338 0.607,-0.569 1.039,-0.693c-0.388,-0.147 -0.693,-0.382 -0.913,-0.704c-0.22,-0.323 -0.33,-0.693 -0.33,-1.111c0,-0.653 0.233,-1.161 0.699,-1.524c0.465,-0.363 1.091,-0.544 1.875,-0.544c0.785,-0 1.412,0.181 1.881,0.544c0.47,0.363 0.704,0.871 0.704,1.524c0,0.418 -0.112,0.79 -0.335,1.116c-0.224,0.327 -0.526,0.559 -0.908,0.699c0.433,0.124 0.778,0.355 1.034,0.693c0.257,0.337 0.385,0.744 0.385,1.221c0,0.682 -0.242,1.212 -0.726,1.589c-0.484,0.378 -1.162,0.567 -2.035,0.567Zm0,-4.4c0.536,-0 0.955,-0.127 1.26,-0.38c0.304,-0.253 0.456,-0.596 0.456,-1.028c0,-0.44 -0.152,-0.783 -0.456,-1.029c-0.305,-0.245 -0.724,-0.368 -1.26,-0.368c-0.535,-0 -0.953,0.123 -1.254,0.368c-0.3,0.246 -0.451,0.589 -0.451,1.029c0,0.432 0.151,0.775 0.451,1.028c0.301,0.253 0.719,0.38 1.254,0.38Zm0,3.652c1.262,-0 1.892,-0.488 1.892,-1.463c0,-0.961 -0.63,-1.441 -1.892,-1.441c-1.261,-0 -1.892,0.48 -1.892,1.441c0,0.975 0.631,1.463 1.892,1.463Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.762,143.468c-0.396,-0 -0.796,-0.085 -1.199,-0.253c-0.404,-0.169 -0.734,-0.396 -0.99,-0.682l0.341,-0.715c0.264,0.286 0.555,0.498 0.874,0.638c0.319,0.139 0.647,0.209 0.985,0.209c0.718,-0 1.272,-0.268 1.661,-0.803c0.388,-0.536 0.583,-1.331 0.583,-2.387l-0,-0.55c-0.147,0.484 -0.409,0.863 -0.787,1.138c-0.377,0.275 -0.823,0.413 -1.336,0.413c-0.455,-0 -0.858,-0.105 -1.21,-0.314c-0.352,-0.209 -0.627,-0.497 -0.825,-0.863c-0.198,-0.367 -0.297,-0.789 -0.297,-1.265c-0,-0.492 0.104,-0.926 0.313,-1.304c0.209,-0.377 0.499,-0.674 0.869,-0.891c0.371,-0.216 0.798,-0.324 1.282,-0.324c0.916,-0 1.622,0.332 2.117,0.995c0.495,0.664 0.743,1.593 0.743,2.789c-0,1.334 -0.275,2.363 -0.825,3.085c-0.55,0.723 -1.317,1.084 -2.299,1.084Zm0.319,-3.751c0.491,-0 0.891,-0.16 1.199,-0.479c0.308,-0.319 0.462,-0.731 0.462,-1.237c-0,-0.514 -0.154,-0.93 -0.462,-1.249c-0.308,-0.319 -0.708,-0.478 -1.199,-0.478c-0.484,-0 -0.88,0.159 -1.188,0.478c-0.308,0.319 -0.462,0.735 -0.462,1.249c-0,0.506 0.154,0.918 0.462,1.237c0.308,0.319 0.704,0.479 1.188,0.479Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.886,143.369l0,-0.77l1.771,-0l0,-5.896l-1.397,0.88l-0.385,-0.671l2.035,-1.298l0.649,-0l0,6.985l1.661,-0l0,0.77l-4.334,-0Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.422,143.468c-0.887,-0 -1.562,-0.341 -2.024,-1.023c-0.462,-0.682 -0.693,-1.669 -0.693,-2.959c0,-1.298 0.231,-2.285 0.693,-2.959c0.462,-0.675 1.137,-1.012 2.024,-1.012c0.895,-0 1.571,0.335 2.03,1.006c0.458,0.671 0.687,1.656 0.687,2.954c0,1.298 -0.233,2.288 -0.698,2.97c-0.466,0.682 -1.139,1.023 -2.019,1.023Zm0,-0.781c0.616,-0 1.073,-0.261 1.37,-0.781c0.297,-0.521 0.445,-1.331 0.445,-2.431c0,-1.1 -0.146,-1.905 -0.44,-2.415c-0.293,-0.509 -0.751,-0.764 -1.375,-0.764c-0.616,-0 -1.072,0.256 -1.369,0.77c-0.297,0.513 -0.446,1.316 -0.446,2.409c0,1.1 0.149,1.91 0.446,2.431c0.297,0.52 0.753,0.781 1.369,0.781Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.719,143.369l-0,-0.77l1.771,-0l-0,-5.896l-1.397,0.88l-0.385,-0.671l2.035,-1.298l0.649,-0l-0,6.985l1.661,-0l-0,0.77l-4.334,-0Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.319,143.369l-0,-0.77l1.771,-0l-0,-5.896l-1.397,0.88l-0.385,-0.671l2.035,-1.298l0.649,-0l-0,6.985l1.661,-0l-0,0.77l-4.334,-0Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.551,143.369l0,-0.77l1.771,-0l0,-5.896l-1.397,0.88l-0.385,-0.671l2.035,-1.298l0.649,-0l0,6.985l1.661,-0l0,0.77l-4.334,-0Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.777,143.369l0,-0.682l2.651,-2.86c0.374,-0.411 0.644,-0.785 0.809,-1.122c0.165,-0.338 0.247,-0.682 0.247,-1.034c0,-0.902 -0.524,-1.353 -1.573,-1.353c-0.784,-0 -1.477,0.293 -2.079,0.88l-0.341,-0.704c0.286,-0.294 0.651,-0.53 1.095,-0.71c0.443,-0.179 0.911,-0.269 1.402,-0.269c0.778,-0 1.373,0.181 1.788,0.544c0.414,0.363 0.621,0.878 0.621,1.546c0,0.462 -0.113,0.915 -0.341,1.358c-0.227,0.444 -0.575,0.915 -1.045,1.414l-2.079,2.222l3.784,-0l0,0.77l-4.939,-0Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.394,88.772l-0,-1.661l-3.575,0l-0,-0.682l3.729,-5.412l0.759,0l-0,5.324l1.155,0l-0,0.77l-1.155,0l-0,1.661l-0.913,0Zm-0,-2.431l-0,-3.839l-2.64,3.839l2.64,0Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.683,88.772l-0,-7.755l0.891,0l-0,4.785l0.022,0l2.475,-2.376l1.133,0l-2.684,2.574l2.915,2.772l-1.133,0l-2.706,-2.508l-0.022,0l-0,2.508l-0.891,0Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.547,48.412c-0.873,0 -1.551,-0.189 -2.035,-0.566c-0.484,-0.378 -0.726,-0.908 -0.726,-1.59c-0,-0.476 0.13,-0.883 0.39,-1.221c0.261,-0.337 0.607,-0.568 1.04,-0.693c-0.389,-0.146 -0.693,-0.381 -0.913,-0.704c-0.22,-0.322 -0.33,-0.693 -0.33,-1.111c-0,-0.652 0.233,-1.16 0.698,-1.523c0.466,-0.363 1.091,-0.545 1.876,-0.545c0.785,0 1.412,0.182 1.881,0.545c0.469,0.363 0.704,0.871 0.704,1.523c-0,0.418 -0.112,0.79 -0.336,1.117c-0.223,0.326 -0.526,0.559 -0.907,0.698c0.433,0.125 0.777,0.356 1.034,0.693c0.257,0.338 0.385,0.745 0.385,1.221c-0,0.682 -0.242,1.212 -0.726,1.59c-0.484,0.377 -1.162,0.566 -2.035,0.566Zm-0,-4.4c0.535,0 0.955,-0.126 1.259,-0.379c0.305,-0.253 0.457,-0.596 0.457,-1.029c-0,-0.44 -0.152,-0.783 -0.457,-1.028c-0.304,-0.246 -0.724,-0.369 -1.259,-0.369c-0.535,0 -0.953,0.123 -1.254,0.369c-0.301,0.245 -0.451,0.588 -0.451,1.028c-0,0.433 0.15,0.776 0.451,1.029c0.301,0.253 0.719,0.379 1.254,0.379Zm-0,3.652c1.261,0 1.892,-0.487 1.892,-1.463c-0,-0.96 -0.631,-1.441 -1.892,-1.441c-1.261,0 -1.892,0.481 -1.892,1.441c-0,0.976 0.631,1.463 1.892,1.463Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.683,48.313l-0,-7.755l0.891,0l-0,4.785l0.022,0l2.475,-2.376l1.133,0l-2.684,2.574l2.915,2.772l-1.133,0l-2.706,-2.508l-0.022,0l-0,2.508l-0.891,0Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.011,7.854l-0,-0.77l1.771,-0l-0,-5.896l-1.397,0.88l-0.385,-0.671l2.035,-1.298l0.649,-0l-0,6.985l1.661,-0l-0,0.77l-4.334,-0Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.811,7.953c-0.917,-0 -1.622,-0.332 -2.117,-0.996c-0.495,-0.663 -0.743,-1.593 -0.743,-2.788c0,-1.342 0.275,-2.372 0.825,-3.091c0.55,-0.719 1.32,-1.078 2.31,-1.078c0.396,-0 0.794,0.084 1.194,0.253c0.399,0.169 0.727,0.396 0.984,0.682l-0.33,0.704c-0.271,-0.279 -0.566,-0.488 -0.885,-0.627c-0.319,-0.139 -0.648,-0.209 -0.985,-0.209c-0.719,-0 -1.27,0.268 -1.655,0.803c-0.385,0.535 -0.578,1.331 -0.578,2.387l0,0.539c0.139,-0.484 0.398,-0.862 0.776,-1.133c0.377,-0.271 0.823,-0.407 1.336,-0.407c0.455,-0 0.858,0.104 1.21,0.313c0.352,0.209 0.627,0.497 0.825,0.864c0.198,0.367 0.297,0.788 0.297,1.265c0,0.491 -0.104,0.926 -0.313,1.303c-0.209,0.378 -0.499,0.675 -0.869,0.891c-0.371,0.217 -0.798,0.325 -1.282,0.325Zm-0.055,-0.77c0.491,-0 0.889,-0.158 1.194,-0.473c0.304,-0.315 0.456,-0.73 0.456,-1.243c0,-0.506 -0.152,-0.919 -0.456,-1.238c-0.305,-0.319 -0.703,-0.478 -1.194,-0.478c-0.491,-0 -0.889,0.159 -1.193,0.478c-0.305,0.319 -0.457,0.732 -0.457,1.238c0,0.513 0.152,0.928 0.457,1.243c0.304,0.315 0.702,0.473 1.193,0.473Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.683,7.854l0,-7.755l0.891,-0l0,4.785l0.022,-0l2.475,-2.376l1.133,-0l-2.684,2.574l2.915,2.772l-1.133,-0l-2.706,-2.508l-0.022,-0l0,2.508l-0.891,-0Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeAnalytics);
export default __webpack_public_path__ + "static/media/home-analytics.0cb2da031ba9e5d3cb053eee6ea52a54.svg";
export { ForwardRef as ReactComponent };